module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_rounded_vector.4a719fc3.svg";